var codeblock_default = {
  "blockStyleSpacing": "T2xDd",
  "codeBlock": "IM6hK T2xDd",
  "renderedInTable": "u86-5"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
